import { createContext, useState } from 'react';

export const BookingContext = createContext();

export const BookingProvider = ({ children }) => {
  const [bookings, setBookings] = useState([]);

  const createBooking = async (bookingData) => {
    try {
      // API call would go here
      const newBooking = {
        id: Date.now().toString(),
        ...bookingData,
        createdAt: new Date().toISOString(),
      };
      
      setBookings((prev) => [...prev, newBooking]);
      return { success: true, booking: newBooking };
    } catch (error) {
      return { success: false, error: error.message };
    }
  };

  const getBookings = () => {
    return bookings;
  };

  const cancelBooking = (bookingId) => {
    setBookings((prev) =>
      prev.map((booking) =>
        booking.id === bookingId
          ? { ...booking, status: 'cancelled' }
          : booking
      )
    );
  };

  return (
    <BookingContext.Provider
      value={{
        bookings,
        createBooking,
        getBookings,
        cancelBooking,
      }}
    >
      {children}
    </BookingContext.Provider>
  );
};

